import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../../types/api';
import { AgencyBookingRate } from '../../types/agency/AgencyBookingRate';

const URL = '/v2/agency-booking-rates';

class AgencyBookingRateService {
  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<AgencyBookingRate>> {
    return axios.get(URL, config);
  }

  static create(
    data: AgencyBookingRate,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AgencyBookingRate>> {
    return axios.post(URL, data, config);
  }

  static patch(
    id: number,
    data: AgencyBookingRate,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AgencyBookingRate>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static delete(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<AgencyBookingRate>> {
    return axios.delete(`${URL}/${id}`, config);
  }
}
export { AgencyBookingRateService };
